<div class="container-sale" id="container-sale">
    <!-- Datos generales -->
    <div class="card mb-3 shadow-sm">
        <div class="card-header text-white">
            <h3 class="mb-0">Realizar Transferencia</h3>
        </div>
        <div class="card-header bg-light">
            <h5 class="mb-0 fw-semibold text-primary">1. Datos generales</h5>
        </div>
        <div class="card-body row g-3">
        <div class="col-sm form-group">
            <label for="bankAccountDebit" class="form-label fw-semibold">Cuenta bancaria a Debitar</label>
            <select class="form-select" [(ngModel)]="bankAccountNumberDebit">
            <option *ngFor="let account of filterAccountsDebit" [ngValue]="account.accountNumber">
                {{ account.alias }} - {{ account.accountNumber }}
            </option>
            </select>
        </div>

        <div class="col-sm form-group">
            <label for="transferType" class="form-label fw-semibold">Tipo de transferencia</label>
            <select class="form-select" [(ngModel)]="transferType">
            <option [ngValue]="0">Cuenta bancaria propia</option>
            <option [ngValue]="1">Cuenta bancaria a terceros</option>
            </select>
        </div>
        </div>
    </div>

    <!-- Datos de transferencia -->
    <div class="card mb-3 shadow-sm">
        <div class="card-header bg-light">
        <h5 class="mb-0 fw-semibold text-primary">2. Datos de transferencia</h5>
        </div>
        <div class="card-body row g-3">

        <!-- Cuentas propias -->
        <div *ngIf="transferType === 0" class="col-12">
            <div class="alert alert-info">
            <label for="ownAccount" class="form-label fw-semibold">Cuenta bancaria propia</label>
            <select class="form-select" [(ngModel)]="selectedOwnAccount">
                <option
                *ngFor="let account of filterAccounts"
                [ngValue]="account.accountNumber"
                [disabled]="account.accountNumber === bankAccountNumberDebit">
                {{ account.alias }} - {{ account.accountNumber }}
                </option>
            </select>
            </div>
        </div>

        <!-- Cuentas a terceros -->
        <div *ngIf="transferType === 1" class="col-12">
            <div class="mb-3">
            <label class="form-label fw-semibold">Cliente</label>
            <div class="input-group input-group-sm">
                <app-input-autocomplete
                [ruleToDisabled]="clients.length == 0"
                [allBorderRadius]="true"
                [inputs]="client"
                [placeholder]="'Ingresa el NIT o nombre del cliente'"
                [filterElements]="client.filterElements"
                [typeElements]="'client'"
                (inputMethod)="writeClient()"
                (changeStatus)="selectClient($event.filterElement, 1)"
                [custom]="true">
                <ng-template #itemsTemplate let-filter>
                    <div items>
                    <h6 class="text-info mb-0">{{filter.name}}</h6>
                    <small class="text-muted">NIT: <b>{{filter.nit}}</b></small>
                    </div>
                </ng-template>
                </app-input-autocomplete>
            </div>
            </div>

            <!-- Cliente seleccionado -->
            <div *ngIf="clientSelected" class="card border-0 shadow-sm p-3 mb-3 bg-light">
            <div><strong>Nombre:</strong> {{ clientSelected.name }}</div>
            <div><strong>NIT:</strong> {{ clientSelected.nit }}</div>
            <div><strong>Código:</strong> {{ clientSelected.code }}</div>
            </div>

            <!-- Cuentas del cliente -->
            <div class="form-group">
            <label for="thirdPartyAccount" class="form-label fw-semibold">Cuenta del cliente</label>
            <select class="form-select" [(ngModel)]="selectedThirdPartyAccount">
                <option *ngFor="let acc of vendorAccounts" [ngValue]="acc.accountNumber">
                {{ acc.accountNumber }} - {{ getBankName(acc.idBank) }} - {{ getBankAccountTypeName(acc.typeBank) }}
                </option>
            </select>
            </div>
        </div>

        <!-- Monto y descripción -->
        <div class="col-sm form-group">
        <label for="amount" class="form-label fw-semibold">Monto</label>
            <div class="input-group">
                <span class="input-group-text">Q</span>
                <input 
                class="form-control text-end" 
                type="number" 
                step="0.01" 
                min="0" 
                [(ngModel)]="amount" 
                (ngModelChange)="updateSuggestedPayments()" 
                placeholder="0.00">
            </div>
            <small class="text-muted">Ingrese el monto en Quetzales (máximo 2 decimales).</small>
        </div>

        <div class="col-sm form-group">
            <label for="description" class="form-label fw-semibold">Descripción</label>
            <input class="form-control" type="text" [(ngModel)]="description" placeholder="Ej. Pago de servicios">
        </div>
        </div>
    </div>

    <!-- Facturas del cliente (Fase 3) -->
    <div *ngIf="transferType === 1 && clientSelected && providersInvoice.length > 0" class="card mb-3 shadow-sm">
    <div class="card-header bg-light">
        <h5 class="mb-0 fw-semibold text-primary">3. Facturas a Pagar</h5>
    </div>

    <div class="card-body">
        <div class="table-responsive">
        <table class="table table-sm table-bordered align-middle">
            <thead class="table-light">
            <tr>
                <th>Fecha Documento</th>
                <th>Días Crédito</th>
                <th>Serie</th>
                <th>Número</th>
                <th>Bodega Recepción</th>
                <th class="text-end">Balance (Q)</th>
                <th class="text-end">Pago Sugerido (Q)</th>
                <th class="text-end">Pago Real (Q)</th>
                <th>Acciones</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let inv of providersInvoice; let i = index">
                <td>{{ inv.documentDate | date:'dd/MM/yyyy' }}</td>
                <td>{{ inv.creditDays }}</td>
                <td>{{ inv.series }}</td>
                <td>{{ inv.number }}</td>
                <td>{{ inv.warehouseName }} ({{ inv.warehouseCode }})</td>
                <td class="text-end">{{ inv.balance | number:'1.2-2' }}</td>

                <!-- Pago sugerido -->
                <td class="text-end">
                {{ inv.suggested | number:'1.2-2' }}
                </td>

                <!-- Pago real -->
                <td class="text-end d-flex">
                <input type="number"
                        step="0.01"
                        class="form-control form-control-sm text-end me-1"
                        [(ngModel)]="inv.paymentReal"
                        [max]="inv.suggested"
                        placeholder="0.00"
                        (input)="validateRealPayments()">
                <!-- <button class="btn btn-sm btn-outline-secondary"
                        type="button"
                        (click)="setRealFromSuggested(i)">
                    ⇨
                </button> -->
                </td>
                <td>
                    <button 
                        class="btn btn-sm btn-outline-info"
                        (click)="viewInvoiceDetail(inv)">
                        <i class="fa fa-eye"></i> Ver detalle
                    </button>
                </td>
            </tr>

            <!-- Mostrar sobrante -->
            <tr *ngIf="remainingAmount > 0" class="table-warning">
                <td colspan="7" class="text-end fw-bold">Sobrante (Se hara un anticipo con este sobrante)</td>
                <td class="text-end fw-bold">{{ remainingAmount | number:'1.2-2' }}</td>
            </tr>
            </tbody>
        </table>
        </div>

        <div class="d-flex justify-content-between align-items-center mt-3">
            <div>
                <button class="btn btn-sm btn-outline-primary" (click)="setAllRealFromSuggested()">
                <i class="fa fa-clone me-1"></i> Usar todos los pagos sugeridos
                </button>
            </div>
            <!-- <div>
                <button class="btn btn-primary" (click)="sendBillsPayment()">
                <i class="fa fa-check me-2"></i> Procesar Pagos Facturas
                </button>
            </div> -->
        </div>

    </div>
    </div>

    <!-- Aviso de anticipo cuando no hay facturas -->
    <div *ngIf="transferType === 1 && clientSelected && providersInvoice.length == 0" class="card mb-3 shadow-sm border-warning">
        <div class="card-body bg-warning bg-opacity-10">
            <div class="d-flex justify-content-between align-items-center">
            <div class="fw-bold text-warning">
                <i class="fa fa-info-circle me-2"></i>
                No se encontraron facturas del cliente. El sobrante se aplicará automáticamente como <u>anticipo</u>.
            </div>
            <div class="fw-bold text-end text-success fs-5">
                Q {{ remainingAmount | number:'1.2-2' }}
            </div>
            </div>
        </div>
    </div>

    <div class="text-center mt-4">
        <button class="btn btn-success btn-lg px-5" (click)="openConfirmModal()">
            <i class="fa fa-paper-plane me-2"></i> Enviar Transferencia
        </button>
    </div>
</div>
<app-modal-dialog
  [title]="'Confirmar Transferencia'"
  [show]="confirmModalVisible"
  [showHeader]="true"
  [showFooter]="false"
  size="md"
  position="center"
  (closed)="onCancelTransfer()"
  (confirmed)="onConfirmTransfer()"
>
    <div modal-body>
        <div class="alert alert-warning d-flex align-items-center">
        <i class="fa fa-exclamation-triangle me-2"></i>
        <span>Revisa cuidadosamente los datos antes de confirmar la transferencia.</span>
        </div>

        <!-- Monto -->
        <p class="fs-5">
        <strong>Monto:</strong> 
        <span class="text-success fw-bold">Q {{ transferPreview?.amount | number:'1.2-2' }}</span>
        </p>

        <!-- Descripcion -->
        <p>
        <strong>Descripción:</strong> 
        <span class="text-muted">{{ transferPreview?.description }}</span>
        </p>

        <!-- Cuenta Origen -->
        <div class="card shadow-sm mb-2">
        <div class="card-body p-2">
            <h6 class="fw-bold text-primary mb-1">Cuenta Origen</h6>
            <div *ngIf="transferPreview?.debitAccount">
            <div>{{ transferPreview.debitAccount.accountNumber }} - {{ transferPreview.debitAccount.alias }}</div>
            <small class="text-muted">
                {{ getBankName(transferPreview.debitAccount.bank) }}
            </small>
            </div>
        </div>
        </div>

        <!-- Cuenta Destino -->
        <div class="card shadow-sm mb-2">
        <div class="card-body p-2">
            <h6 class="fw-bold text-primary mb-1">Cuenta Destino</h6>
            <div *ngIf="transferPreview?.creditAccount">
            <div> {{ transferPreview.creditAccount.accountNumber }} {{ transferPreview.creditAccount.alias != null ? (" - " + transferPreview.creditAccount.alias) : "" }} </div>
            <small class="text-muted">
                {{ getBankName(transferPreview.creditAccount.idBank != null ? transferPreview.creditAccount.idBank : transferPreview.creditAccount.bank) }}
            </small>
            </div>
        </div>
        </div>

        <div class="card shadow-sm mb-2">
            <div class="card-body p-2">
                <h6 class="fw-bold text-primary mb-1">Código</h6>
                <div *ngIf="!showInputCode">
                    <button class="btn btn-link" [disabled]="loadingSendCode" (click)="sendRequestCode()">
                        Solicitar Codigo
                        <span *ngIf="loadingSendCode" class="spinner-border spinner-border-sm me-2"></span>
                    </button>
                </div>
                <div *ngIf="showInputCode">
                    <div class="input-group">
                        <input 
                        class="form-control" 
                        type="text"
                        [(ngModel)]="code2fa" >
                        <button class="btn btn-success" (click)="pastClipboard()">
                            <i class="fa fa-clipboard"></i>
                        </button>
                    </div>
                    <button class="btn btn-link" [disabled]="loadingSendCode" (click)="sendRequestCode()">
                        Volver a solicitar código
                        <span *ngIf="loadingSendCode" class="spinner-border spinner-border-sm me-2"></span>
                    </button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="card-body p-3">
                <div class="col">
                    <button class="btn btn-secondary btn-block" (click)="onCancelTransfer()">Cancelar</button>
                    <button class="btn btn-primary btn-block" (click)="onConfirmTransfer()" *ngIf="showInputCode && code2fa">Finalizar</button>
                </div>
            </div>
        </div>
    </div>
</app-modal-dialog>
<!-- Modal Detalle Factura -->
<div class="modal fade show d-block" tabindex="-1" *ngIf="invoiceDetail">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Detalle de Factura</h5>
        <button type="button" class="btn-close btn-close-white" (click)="closeInvoiceDetail()"></button>
      </div>

      <div class="modal-body">
        <p><strong>Serie:</strong> {{ invoiceDetail.series }}</p>
        <p><strong>Número:</strong> {{ invoiceDetail.number }}</p>
        <p><strong>Fecha:</strong> {{ invoiceDetail.dateString }}</p>

        <div class="table-responsive">
          <table class="table table-sm table-bordered">
            <thead class="table-light">
              <tr>
                <th>Cantidad</th>
                <th>Producto</th>
                <th>Precio (Q)</th>
                <th>Total (Q)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of invoiceDetail.detail">
                <td class="text-center">{{ item.quantity }}</td>
                <td>{{ item.productData?.name }}</td>
                <td class="text-end">{{ item.price | number:'1.2-2' }}</td>
                <td class="text-end">{{ (item.quantity * item.price) | number:'1.2-2' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeInvoiceDetail()">Cerrar</button>
      </div>
    </div>
  </div>
</div>

